import * as React from "react";
import { useEffect } from "react";

export const TIMER_5S_WRAPPER_CLASSNAME = "timer-5s";

type Props = {
  onTimeout: () => void;
};

export default function Timer5s({ onTimeout }: Props) {
  useEffect(() => {
    // Adding 100ms delay. It allows animation to fully finish.
    const timer = window.setTimeout(onTimeout, 5100);
    return () => window.clearTimeout(timer);
  });

  return (
    <div className="timer-5s__counter">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={24} height={24}>
        <circle cx={12} cy={12} r={10} />
      </svg>
    </div>
  );
}
